<script setup lang="ts">
    import type { LabelProps } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { Label } from 'reka-ui';
    import { cn } from '../utils';

    const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <Label
        data-slot="label"
        v-bind="delegatedProps"
        :class="
            cn(
                'flex items-center gap-2 leading-none font-medium select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
                'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-content-subdued',
                'font-semibold',
                props.class,
            )
        "
    >
        <slot />
    </Label>
</template>
